import { combineReducers } from 'redux';
import demoReducer from './DemoReducer';
import loggedInStatus from './loggedInStatus';
import swappedPositionsReducer from './swappedPositionsReducer';
import hoverSourceReducer from './hoverSourceReducer';

const rootReducer = combineReducers({
  demoReducer,
  loggedInStatus,
  swappedPositions: swappedPositionsReducer,
  hoverSource: hoverSourceReducer,
});

export default rootReducer;
